import Router from './Router'
import { ThemeProvider } from './context/ThemeContextProvider'

function App() {
    return (
        <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
            <Router />
        </ThemeProvider>
    )
}

export default App
